<template>
    <div
        class="type-selector"
        :class="disabled ? 'type-selector-disabled' : ''"
    >
        <div class="type-list">
            <div
                v-for="(item, index) of list"
                :key="index"
                class="type-item"
                :class="item === innerValue ? 'selected' : ''"
                @click="handleClick(item)"
            >
                {{ item }}
            </div>
        </div>
        <veui-pagination
            :page="pn"
            :page-size="rn"
            :total="total"
            :show-total="false"
            @redirect="pageChange"
        />
    </div>
</template>
<script>
import {Pagination} from 'veui';
import {TYPE_LIST} from '../util';

export default {
    components: {
        'veui-pagination': Pagination
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: {
            handler(val) {
                this.innerValue = val;
            },
            immediate: true
        }
    },
    data() {
        return {
            innerValue: '',
            list: TYPE_LIST.slice(0, 8),
            pn: 1,
            rn: 8,
            total: TYPE_LIST.length
        };
    },
    methods: {
        pageChange(val) {
            this.pn = val;
            const {pn, rn} = this;
            this.list = TYPE_LIST.slice((pn - 1) * rn, pn * rn);
            this.$wywLog.send({
                serverId: 17047,
                action: 'click',
                area: 'htlx-lb-hy',
                pagetype: pn
            });
        },
        handleClick(item) {
            if (!this.disabled && this.innerValue !== item) {
                this.innerValue = item;
                this.$emit('input', item);
                this.$emit('change', item);
                this.$wywLog.send({
                    serverId: 17047,
                    action: 'click',
                    area: 'htlx-lb',
                    contracttype: encodeURIComponent(item)
                });
            }
        }
    }
};
</script>
<style lang="less" scoped>
.type-selector {
    display: flex;
    flex-direction: column;
    height: 240px;
    justify-content: space-between;
    .type-list {
        display: flex;
        flex-wrap: wrap;
        margin-right: -13px;
        .type-item {
            cursor: pointer;
            margin-right: 12px;
            margin-bottom: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 183px;
            height: 40px;
            background: #f6f8f9;
            border-radius: 4px;
            box-sizing: border-box;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #333333;
            text-align: center;
            line-height: 14px;

            &:hover {
                border: 1px solid #0055ff;
            }

            &.selected {
                border: 1px solid #0055ff;
                color: #0055ff;
                background-color: rgba(56, 85, 213, 0.08);
            }
        }
    }
    &.type-selector-disabled {
        .type-item.selected {
            color: #7faaff;
            border: 1px solid #7faaff;
        }
    }

    /deep/.veui-pagination {
        width: 100%;
        justify-content: flex-end;
        .veui-pagination-prev,
        .veui-pagination-next {
            display: none;
        }
        .veui-pagination-page {
            .veui-link {
                color: #333;
                background: #fff;
                border: 1px solid #e9ecf3;
                border-radius: 4px;

                &:hover {
                    border-color: #999;
                }
            }
            &.veui-active .veui-link {
                background: #fff;
                border-color: #999;
            }
        }
    }
}
</style>